<template>
  <div
    class="field"
    :class="{ 'field--error': error }"
  >
    <span
      v-if="label"
      ref="leftRef"
      class="left"
    >
      <h6>{{ label }}</h6>
    </span>
    <span
      class="right"
      :style="{ width: rightWidth }"
    >
      <slot />
    </span>
  </div>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue'
import { useElementSize } from '@vueuse/core'

defineProps({
  label: {
    type: String,
    required: false,
    default: '',
  },
  error: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const leftRef = ref(null)
const { width: leftWidth } = useElementSize(leftRef)

const rightWidth = computed(() => {
  const totalWidth = 100
  const leftSize = leftWidth.value || 0
  return `calc(${totalWidth}% - ${leftSize}px - 16px)`
})
</script>

<style lang="scss" scoped>
.field {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  flex-wrap: nowrap;
  height: 50px;
  padding: 8px 0;
  width: 100%;

  &--error {
    border-color: #e53935;
  }

  .left {
    border-right: 1px solid #ccc;
    flex: 0 0 auto;
    padding: 0 8px;
    min-width: 50px;
    max-width: 50%;
    white-space: nowrap;
  }

  .right {
    padding: 0 8px;
    position: relative;
    align-items: center;
  }

  h6 {
    padding: 8px;
    font-weight: 500;
    font-size: 13px;
    color: #999;
  }
}
</style>
